<div class="card-item">

    <!-- 📌 Header -->
    <div class="card-header">
        <div class="card-title">{{ item.title }}</div>
        <div class="card-subinfo">
            <span class="card-category">{{ item.categories }}</span>
            <div class="card-date">
                {{ getTimeAgo() }}
                <lucide-icon name="Clock" class="date-icon"></lucide-icon>
            </div>
        </div>
    </div>

    <!-- 📌 Divider Line -->
    <div class="card-divider"></div>

    <!-- 📌 Client and Lawyer -->
    <div class="card-info">
        <div class="client-info">
            <div class="card-client">
                <lucide-icon name="User" class="card-info-icon"></lucide-icon>
                <span [ngClass]="{'bold-text': item.clientStrong}">{{ item.clientName }}</span>
            </div>
            <div class="card-lawyer">
                <lucide-icon name="Scale" class="card-info-icon"></lucide-icon>
                <span>{{ item.userName || '-' }}</span>
            </div>
        </div>
         <!-- 🔄 Translated status -->
  <div class="card-status">
    <div class="status-tags">
      @if (item.status === 'UNASSIGNED') {
        <app-tag
          [label]="'common.cardStatus.unassigned' | transloco"
          color="gray"
        ></app-tag>
      }
      @if (item.status === 'CLOSED') {
        <app-tag
          [label]="'common.cardStatus.closed' | transloco"
          color="red"
        ></app-tag>
      }
      @if (item.status === 'PENDING_RESPONSE_CLIENT') {
        <app-tag
          [label]="(userRole === 'client' ? 'common.cardStatus.pendingResponse' : 'common.cardStatus.active') | transloco"
          [color]="userRole === 'client' ? 'yellow' : 'green'"
        ></app-tag>
      }
      @if (item.status === 'PENDING_RESPONSE_USER') {
        <app-tag
          [label]="(userRole === 'client' ? 'common.cardStatus.active' : 'common.cardStatus.pendingResponse') | transloco"
          [color]="userRole === 'client' ? 'green' : 'yellow'"
            ></app-tag>
        }
        </div>
    </div>
    </div>

    <!-- 📌 Status + Actions -->
    <div class="card-footer">

        <div class="card-actions">
            <a class="card-link" (click)="onViewClick()">
                {{ 'common.cardStatus.viewInquiry' | transloco }} <lucide-icon name="ArrowRight"></lucide-icon>
            </a>
            
            <app-button 
              class="ellipsis-button" 
              [icon]="'ellipsis-vertical'"
              [ariaLabel]="'common.labels.actions' | transloco"
              (onClick)="openActionMenu($event.target, (getMenuActions?.(item) || []), item)"
            ></app-button>
        </div>
    </div>

  
</div>